'use client';

import { useEffect } from 'react';
import { setCustomerIOOnline } from '@/helpers/customerio';
import { useGetCommonStore } from '@/store';

const PRESENCE_REFRESH_INTERVAL = 60e3;

export const usePlayerPresence = () => {
  const useCommonStore = useGetCommonStore();
  const userId = useCommonStore.use.user()?.id;
  const isAuthenticated = useCommonStore.use.isAuthenticated();

  useEffect(() => {
    if (!(isAuthenticated && userId)) return;

    const update = () =>
      setCustomerIOOnline(userId, document.visibilityState === 'visible');
    const goOffline = () => setCustomerIOOnline(userId, false);
    const refresh = () => {
      if (document.visibilityState === 'visible') {
        setCustomerIOOnline(userId, true);
      }
    };

    update();
    const interval = setInterval(refresh, PRESENCE_REFRESH_INTERVAL);
    document.addEventListener('visibilitychange', update);
    window.addEventListener('pageshow', update);
    window.addEventListener('pagehide', goOffline);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', update);
      window.removeEventListener('pageshow', update);
      window.removeEventListener('pagehide', goOffline);
    };
  }, [isAuthenticated, userId]);
};
